import React, { Component } from 'react';
import { Drawer, Table, Row, Button } from 'antd';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import ReconcilerSmartActionsAddEdit from './recon_actions_addedit';
import Title from 'antd/lib/typography/Title';
import UnReconcilerSmartActionsAddEdit from './unrecon_actions_addedit';
import { formatMoney } from '../../../lib/util';


const action_cols=({onEditPressed})=>[
  {
    title:"Action Name",
    dataIndex:'name',
    key:'name'
  },
  {
    title:"Plugin",
    dataIndex:'plugin_id',
    key:'plugin_id',
    // render:(reference)=>{
    //   let plugin=reference.plugin_id||{};

    //   return plugin.name
    // }
  },
  {
    title:"Action",
    key:'action',
    dataIndex:'id',
    render:(id,data)=><span>
      <Button type='link' onClick={()=>{
        typeof onEditPressed==='function'&&onEditPressed(data)
      }}>
        Edit
      </Button>
    </span>
  }
]
class UnReconcilerSmartActions extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
          // supports 'add' or 'edit'
          drawer_type: null,
          selected_action: null,
          recon_id: this.props.recon_id
        }
        this.list_actions = RESTExecutor.list().config({
          label: 'unrecon_smart_actions',
          params: {
            rule_id: this.props.recon_id
          }
        }).connect(props.domains.settings);
    
        if (this.props.recon_id) {
          this.list_actions.execute();
        }
      }
    
      render() {
        let list_actions_resp = this.list_actions.response();
        let list_actions_data = list_actions_resp.result || {};
        let rowsData = list_actions_data.rows || [];
        let rowsMeta = list_actions_resp.meta || {};
    
        return (
          <div>
            <Table
            scroll={{x:true}}
              dataSource={rowsData}
              className='ant-table-small-noborder customTable'
              loading={list_actions_resp.fetching}
              title={() => <Row type='flex' justify='space-between' style={{
                alignItems: 'center'
              }}><div></div>
                  <Button type='primary' onClick={()=>{
                    this.setState({
                      drawer_type:'add',
                      selected_action:null
                    })
                  }}>Add New Action</Button>
              </Row>}
              columns={action_cols({
                onEditPressed:(data)=>{
                  this.setState({
                    drawer_type:'edit',
                    selected_action:data
                  })
                }
              })}
              size='small'
              rowKey={(record) => record.id}
              pagination={{
                simple: false,
                    position:'bottom',
                onChange: (current, size) => {
                  this.list_actions.config({
                    params: {
                      per_page: size,
                      page: current,
                      rule_id:this.props.recon_id
                    }
                  }).execute();
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                // defaultPageSize: 20,
                pageSize: (rowsMeta && rowsMeta.requested_count),
    
                total: (rowsMeta && rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
              }}
            />
            <Drawer 
            title={<Title level={3} style={{margin:0}}>Add Unreconciled Action</Title>}
            placement="right"
            closable={false}
            width='50%'
            destroyOnClose
            onClose={() => {
                this.setState({
                    drawer_type: null,
                    selected_action:null
                })
                this.list_actions.execute()

            }}
            visible={this.state.drawer_type==='add'}
            >
              <UnReconcilerSmartActionsAddEdit 
                recon_id={this.state.recon_id}
                onClose={() => {
                  this.setState({
                      drawer_type: null,
                      selected_action:null
                  });
                  this.list_actions.execute()
              }}
              />
            </Drawer>
    
            <Drawer 
            title={<Title level={3} style={{margin:0}}>Edit Smart Action</Title>}
            placement="right"
            closable={false}
            width='50%'
            destroyOnClose
            onClose={() => {
                this.setState({
                    drawer_type: null,
                    selected_action:null
                });
                this.list_actions.execute()

            }}
            visible={this.state.drawer_type==='edit'}
            >
              <UnReconcilerSmartActionsAddEdit 
              data={this.state.selected_action}
              recon_id={this.state.recon_id}
              action_id={this.state.selected_action&&this.state.selected_action.id}
              onClose={() => {
                this.setState({
                    drawer_type: null,
                    selected_action:null
                });
                this.list_actions.execute()

            }}
              />
            </Drawer>
    
    
          </div>
        );
    
      }
    }

export default withDomains(UnReconcilerSmartActions,"settings");
